// Import; Three
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { Html } from "@react-three/drei";

import ArrowIcon from "./ArrowIcon";

import styled from "@emotion/styled";
import { useState } from "react";
import { useControls } from "leva";

// Styling for the wrapper
const Hotspot = styled("div")(({ theme }) => ({
  borderStyle: "solid",
  borderWidth: 5,
  borderColor: "#686565",
  height: 75,
  width: 75,
  borderRadius: "50%",
  backgroundColor: "rgba(104, 101, 101, 0.5)",
  transition: "width 0.9s, border-radius 0.3s, display 3.5s",
  textAlign: "center",
  "&:hover": {
    // paddingBottom: 30,
    display: "flex",
    alignItems: "center",
    minWidth: 150,
    borderRadius: 75,
    cursor: "pointer",
  },
  "&:hover .imageWrapper": {
    display: "none",
  },
  "&:hover .content": {
    display: "block",
    // verticalyAlign: "middle",
    opacity: 1,
    fontSize: 20,
    // padding: 5,
    marginTop: 1,
    // background: "green",
    padding: "0px 15px",
    width: "100%",
    textAlign: "center",
  },
}));

// Styling for the wrapper
const Content = styled("div")(({ theme }) => ({
  display: "none",
}));

const ContentIcon = styled("div")(({ theme }) => ({
  paddingTop: "6px",
}));

//-----------------------------------------------------------------------------------------------
// Hotspot component; render the movment, content and board hotspots
export default function Arrow({
  hotspot,
  onHotspotClick,
  currentScene,
  machineLoading,
}: any) {
  const matches = useMediaQuery("(min-width:600px)");

  // const controller = useControls({
  //   [`${hotspot.id}-x`]: { value: hotspot.position.x, min: -100, max: 100 },
  //   [`${hotspot.id}-y`]: { value: hotspot.position.y, min: -100, max: 100 },
  //   [`${hotspot.id}-z`]: { value: hotspot.position.z, min: -100, max: 100 },

  //   [`${hotspot.id}-scale`]: { value: hotspot.scale, min: -100, max: 100 },

  //   [`${hotspot.id}-r-x`]: {
  //     value: hotspot.rotation.x,
  //     min: -360,
  //     max: 360,
  //   },
  //   [`${hotspot.id}-r-y`]: {
  //     value: hotspot.rotation.y,
  //     min: -360,
  //     max: 360,
  //   },
  //   [`${hotspot.id}-r-z`]: {
  //     value: hotspot.rotation.z,
  //     min: -360,
  //     max: 360,
  //   },
  // });

  return (
    <mesh
      position={[hotspot.position.x, hotspot.position.y, hotspot.position.z]}
    >
      <Html scale={10} zIndexRange={[1, 0]} center={true}>
        {/* <Hotspot
          onClick={() => {
            onHotspotClick();
          }}
        >
          <Content className={"content"}>{hotspot.title}</Content>
    
        </Hotspot> */}
        <div
          style={{
            width: "160px",
            height: "48px",
            background: " #00569c",
            color: "white",
            borderRadius: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            cursor: "pointer",
            border: "2px solid #00569c",
            fontWeight: 600,
            fontSize: "1.1rem",
            transition: "transform 0.2s, box-shadow 0.2s",
          }}
          onClick={() => {
            onHotspotClick();
            console.log(
              "****************** Clicked Hotspot ******************"
            );
          }}
          onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.97)")}
          onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Typography
            align="center"
            sx={{
              color: "white",
              textShadow: "0 1px 4px #00569c",
              letterSpacing: "0.03em",
              fontWeight: 700,
            }}
          >
            {machineLoading ? "Machine Loading" : hotspot?.title || "Load Medicine"}
          </Typography>
        </div>
      </Html>
    </mesh>
  );
}
